document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaMarquee();
  initColorScroll();
  initGaleriaProducto();
  initVariantes();
  initCantidad();
});

/* Reveal on scroll compartido por todas las secciones */
function initReveal() {
  var els = document.querySelectorAll('.asa-reveal, .ln-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('asa-visible', 'ln-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-asa-delay') || entry.target.getAttribute('data-ln-delay') || 0;
        var visibleClass = entry.target.classList.contains('ln-reveal') ? 'ln-visible' : 'asa-visible';
        setTimeout(function () { entry.target.classList.add(visibleClass); }, Number(delay));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

/* Duplica el contenido de la marquesina de galería para el loop infinito */
function initGaleriaMarquee() {
  var track = document.querySelector('[data-asa-marquee]');
  if (!track) return;
  track.innerHTML += track.innerHTML;
}

/* Los botones de "elige tu color" llevan al selector de variantes del producto si existe, o a la colección */
function initColorScroll() {
  var swatches = document.querySelectorAll('[data-asa-color-link]');
  swatches.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.querySelector('.asa-opciones');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });
}

/* Galería de la página de producto: clic en miniatura cambia la imagen principal */
function initGaleriaProducto() {
  var principal = document.querySelector('[data-asa-imagen-principal]');
  var minis = document.querySelectorAll('[data-asa-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      if (!src) return;
      principal.src = src;
      minis.forEach(function (m) { m.classList.remove('is-active'); });
      mini.classList.add('is-active');
    });
  });
}

/* Selector de variantes: actualiza precio, id oculto y estado de stock */
function initVariantes() {
  var wrapper = document.querySelector('[data-asa-producto]');
  if (!wrapper) return;
  var dataEl = wrapper.querySelector('[data-asa-variantes-json]');
  if (!dataEl) return;

  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var pills = wrapper.querySelectorAll('.asa-opcion-pill');
  var hiddenInput = wrapper.querySelector('[data-asa-variant-id]');
  var precioActual = wrapper.querySelector('[data-asa-precio-actual]');
  var precioAntes = wrapper.querySelector('[data-asa-precio-antes]');
  var botonComprar = wrapper.querySelector('[data-asa-comprar]');
  var stockTexto = wrapper.querySelector('[data-asa-stock]');
  var numOpciones = wrapper.querySelectorAll('.asa-opciones').length;

  function seleccionActual() {
    var seleccion = [];
    for (var i = 0; i < numOpciones; i++) {
      var activo = wrapper.querySelector('.asa-opciones[data-asa-index="' + i + '"] .asa-opcion-pill.is-selected');
      seleccion.push(activo ? activo.getAttribute('data-value') : null);
    }
    return seleccion;
  }

  function encontrarVariante(seleccion) {
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
  }

  var moneyFormat = wrapper.getAttribute('data-money-format') || '${{amount}}';
  function formatoMoneda(centavos) {
    var valor = (centavos / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(centavos / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, valor.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, valor);
  }

  function actualizar() {
    var seleccion = seleccionActual();
    var variante = encontrarVariante(seleccion);
    if (!variante) return;

    if (hiddenInput) hiddenInput.value = variante.id;
    if (precioActual) precioActual.textContent = formatoMoneda(variante.price);
    if (precioAntes) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAntes.textContent = formatoMoneda(variante.compare_at_price);
        precioAntes.hidden = false;
      } else {
        precioAntes.hidden = true;
      }
    }
    if (botonComprar) {
      botonComprar.disabled = !variante.available;
      botonComprar.textContent = variante.available ? botonComprar.getAttribute('data-texto-disponible') : botonComprar.getAttribute('data-texto-agotado');
    }
    if (stockTexto) {
      stockTexto.className = 'asa-compra__stock';
      if (!variante.available) {
        stockTexto.textContent = stockTexto.getAttribute('data-texto-agotado');
        stockTexto.classList.add('asa-compra__stock--agotado');
      } else {
        stockTexto.textContent = stockTexto.getAttribute('data-texto-disponible');
        stockTexto.classList.add('asa-compra__stock--ok');
      }
    }

    // Actualiza qué pills quedan deshabilitadas por falta de combinación disponible
    pills.forEach(function (pill) {
      var index = pill.closest('.asa-opciones').getAttribute('data-asa-index');
      var valor = pill.getAttribute('data-value');
      var pruebaSeleccion = seleccion.slice();
      pruebaSeleccion[index] = valor;
      var existe = variantes.some(function (v) {
        return v.options.every(function (opt, i) { return pruebaSeleccion[i] === null || opt === pruebaSeleccion[i]; });
      });
      pill.disabled = !existe;
    });
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var grupo = pill.closest('.asa-opciones');
      grupo.querySelectorAll('.asa-opcion-pill').forEach(function (p) { p.classList.remove('is-selected'); });
      pill.classList.add('is-selected');
      actualizar();
    });
  });

  actualizar();
}

/* Selector de cantidad +/- en la página de producto */
function initCantidad() {
  var cont = document.querySelector('[data-asa-cantidad]');
  if (!cont) return;
  var input = cont.querySelector('input');
  cont.querySelectorAll('button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var delta = Number(btn.getAttribute('data-delta'));
      var valor = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
      input.value = valor;
    });
  });
}
